import api from "../api/axiosInstance";

// get user interests
export const getUserInterests = async () => {
  try {
    const response = await api.get("/interests/stats");
    return response.data;
  } catch (error) {
    console.error("Error fetching user interests:", error);
    throw error;
  }
};

//Accept interest request
export const acceptInterestRequest = async (id) => {
  try {
    const response = await api.put(`/interests/accept/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error accepting interest request:", error);
    throw error;
  }
};

//Decline interest request
export const declineInterestRequest = async (id) => {
  try {
    const response = await api.put(`/interests/reject/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error declining interest request:", error);
    throw error;
  }
};